import ProxyBase from '../../../../core/proxies/ProxyBase'

class CategoryProxy extends ProxyBase {
  getOwnershipTypes(params) {
    return this.get('OwnershipTypes', params)
  }
}

export default new CategoryProxy('Category/')
